import classNames from "classnames";
import noop from "lodash/noop";
import React, { FunctionComponent, MouseEvent } from "react";
import HeaderAccount from "@Components/atoms/header/HeaderAccount";
import { HeaderMenuLink } from "@Types/header";
import "./style.scss";

interface Props {
  active: boolean;
  links: HeaderMenuLink[];
  onMouseLeave: (event: MouseEvent) => void;
  top: number;
}

const HeaderSideLinkMenu: FunctionComponent<Props> = ({
  active,
  links,
  onMouseLeave = noop,
  top,
}) => {
  return (
    <div
      className={classNames("HeaderSideLinkMenu", {
        "HeaderSideLinkMenu--active": active,
      })}
      onMouseLeave={onMouseLeave}
      style={{ top: `${top}px` }}
    >
      <HeaderAccount accountLinks={links} />
    </div>
  );
};

export default HeaderSideLinkMenu;
